import { useState } from "react";
import "./style/StrechedBlock.css"

export default function RadioButton({ header, text }) {
    const [open, setOpen] = useState(false);
    const toggle = () => setOpen(!open);

    return (
        <>
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", gap: 0, width: "100%", marginBottom: "-24px"}}>
            <div className={`strechedWrapper ${open ? "open" : ""}`} onClick={toggle}>
                {header}
                <svg className={`plus-minus ${open ? "open" : ""}`} width="16" height="16" viewBox="0 0 16 16">
                    <line className="horizontal" x1="0" y1="8" x2="16" y2="8" stroke="#086BFF" strokeWidth="2" />
                    <line className="vertical" x1="8" y1="0" x2="8" y2="16" stroke="#086BFF" strokeWidth="2" />
                </svg>
            </div>
            <div className={`streched-content ${open ? "open" : ""}`}>{text}</div>
        </div>
        </>
    );
}
